/**
 * 主题系统（dark-only）。
 *
 * Tsuvi 取消浅色风格，全站固定深色。本模块保留原公开 API（detectTheme / applyTheme /
 * currentTheme / Theme / SUPPORTED_THEMES），避免破坏既有引用，但内部恒为 "dark"，
 * 不再读取 localStorage 或监听 prefers-color-scheme。
 *
 * data-theme="dark" 由 index.html 静态写入 <html> 标签（原为内联脚本，为 CSP
 * 去 'unsafe-inline' 迁出）；applyTheme 在 React 启动时补齐（双保险）。
 */

export type Theme = "light" | "dark";
export const SUPPORTED_THEMES = ["light", "dark"] as const;

/** 固定深色：全站唯一主题。 */
const FIXED_THEME: Theme = "dark";

/** 固定深色。 */
export function detectTheme(): Theme {
  return FIXED_THEME;
}

/** 仅写 <html data-theme="dark">；不再持久化（无意义）。 */
export function applyTheme(_theme?: Theme): void {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.theme = FIXED_THEME;
  }
}

/** 固定 "dark"。 */
export function currentTheme(): Theme {
  return FIXED_THEME;
}
